<template>
  <div>

    <v-container grid-list-md>

      <div>
        <span class="title">Dashboard</span>
      </div>

      <v-layout column>
        <span class="subheading mb-4">Version 1.1</span>

        <!-- super user -->
        <div v-if="$accessControl.userHasAccess(0, $store.state.auth.accessControl)">
          <v-layout>
            <v-flex xs12 sm4>
              <v-card>
                <v-layout align-center justify-center class="vue-gamestore-img ma-0 headline white--text">
                  VUETIFY PREMIUM
                </v-layout>
                <v-layout class="pa-3 font-weight-medium">
                  <a href="https://material-launcher.vuetifyjs.com/" target="_blank">VISIT</a>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4>
              <v-card style="height: 100%;">
                <v-layout class="pl-3 pr-3 crx-toolbar align-center subheading font-weight-bold">
                  Reminders
                </v-layout>
                <div class="pa-2">
                  <v-chip color="pink" text-color="white">
                    DONT FORGET DB MIGRATION NECESSARY
                  </v-chip>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
          <a href="https://smartslider3.com/pro-features/?utm_source=dashboard-why-upgrade&utm_campaign=smartslider3&utm_medium=smartslider-wordpress-free">Smart slider. best site</a>
          <a href="https://blog.bitsrc.io/5-tools-for-faster-vue-js-app-development-ad7eda1ee6a8">Vuejs productivity 5X and storybook</a>
          <div>
            Every 
            <span class="blue--text">button</span>,
            <span class="red--text">line</span>, 
            <span class="amber--text">shadow</span>,
            <span class="purple--text font-weight-bold">Font size, font color, and font weight</span>,
              
            adds to mental fatigue
          </div>

          <div>
            Keep it simple for a brand new user to intuitivelt navigate. Hide advanced options in advanced menus
          </div>
          
        </div> <!-- end main div -->
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 6
    }
  }
}
</script>

<style scoped>
.vue-gamestore-img {
  background-image: url(https://material-launcher.vuetifyjs.com/img/bg.9e906a27.png);
  background-position: center center;
  background-size: cover;
  height: 300px;
}
</style>
